import Vue from "vue";
import Router from "vue-router";
import Main from "./components/Main.vue";
import FileEdit from "./components/FileEdit.vue";
import FileCreate from "./components/FileCreate.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { 
      path: '/',
      component: Main
    },
    { 
      path: '/edit',
      component: FileEdit
    },
    { 
      path: '/create',
      component: FileCreate,
    },
    { 
      path: '/:catchAll(.*)',
      redirect: '/' 
    }
  ]
});
